import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function invoice(state=initialState.invoice, action) {
    switch (action.type) {
        case commonConstants.INVOICE_RECONCILIATION_SUCCESS:
            return Object.assign({}, state, action.invoice);
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/invoice.reconciliation.reducer.js